<template>
    <div class="box" :class="{community: this.$route.path.includes('/community'), logo: ['/introduction', '/latestNews'].includes(this.$route.path) || this.$route.path.includes('coop')}">
        <div class="wrapper">
            <div id="logo">
                <img src="./../../assets/resource/home/partner.png" alt="">
            </div>
            <div>
                <i class='fa fa-list-ul fa-1x' @click="showNav = !showNav"></i>
                <div id="links" v-if="showNav">
                    <router-link :to="{path:'/home'}" class="text us">{{ $t("Home.title1") }}</router-link>
                    <router-link :to="{path:'/introduction'}" class="text">{{ $t("Home.title2") }}</router-link>
                    <div class="more">
                        <router-link :to="{path:'/latestNews'}" class="text list">{{ $t("Home.title3") }}</router-link>
                        <div class="cooperation news">
                            <router-link :to="{path:'/latestNews?column=“畅”响'}">“畅”响</router-link>
                            <router-link :to="{path:'/latestNews?column=“畅”谈'}">“畅”谈</router-link>
                            <router-link :to="{path:'/latestNews?column=“畅”达'}">“畅”达</router-link>
                        </div>
                    </div>
                    <div class="more">
                        <router-link :to="{path:'/coop/mode'}" class="text list">{{ $t("Home.title4") }}</router-link>
                        <div class="cooperation coop">
                            <router-link :to="{path:'/coop/school'}">学校合作</router-link>
                            <router-link :to="{path:'/coop/join'}">机构加盟</router-link>
                            <router-link :to="{path:'/coop/channel'}">渠道经销</router-link>
                            <router-link :to="{path:'/coop/case'}">合作案例</router-link>
                        </div>
                    </div>
                    <router-link :to="{path:'/community'}" class="text" target= '_blank'>{{ $t("Home.title5") }}</router-link>
                    <a href="javascript:void(0)" @click="scrollToBottom" class="text">{{ $t("Home.title6") }}</a>
                </div>
            </div>
            <div class="selectLan">
                <select class='languageMenu' @change='changeLanguage'>
                    <option value='en-US' :selected="$i18n.locale === 'en-US'">English</option>
                    <option value='zh-TW' :selected="$i18n.locale === 'zh-TW'">正體中文</option>
                    <option value='zh-CN' :selected="$i18n.locale === 'zh-CN'">简体中文</option>
                </select>
            </div>
            <i class="fa fa-share-alt" @click="dialogVisible=true" v-if="this.$route.query.school === 'changning'"></i>
        </div>
        <div class="header-logo" v-if="['/introduction', '/latestNews'].includes(this.$route.path) || this.$route.path.includes('coop')">
            <div class="logo-container">
                <router-link :to="{path: '/'}">
                    <img :src="logo"/>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { setLocalStore } from '../../lib/mUtils'
import logo from '@/assets/resource/home/logo.png'
export default {
    data() {
        return {
            logo,
            showNav: false,
            screenWidth: 0
        }
    },
    created() {
        this.JudgmentLanguage()
    },
    methods: {
        JudgmentLanguage() {
            if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.isMobile = true
                this.showNav = false
            } else {
                this.isMobile = false
                this.showNav = true
            }
        },
        changeLanguage(e) {
            this.$i18n.locale = e.target.value
            setLocalStore('vue-language', e.target.value)
        },
        scrollToBottom() {
      // 获取页面底部元素
      const bottomElement = document.getElementById('contact-us');
      bottomElement.scrollIntoView({ behavior: 'smooth' });
    }
    }
}
</script>

<style lang='scss' scoped>
@import './../../assets/css/mixin.scss';
@media screen and (max-width: 769px) and (min-width: 415px) {
    .box {
        width: 100%;
        background: #edae24;
        margin-top: -80px;
        border-bottom: 1px solid #eee;
        .wrapper {
            max-width: 1170px;
            height: 96px;
            margin: 0 auto;
            #logo {
                float: left;
                margin-top: 38px;
            }
            #links {
                display: flex;
                max-width: 460px;
                margin-top: 45px;
                color: #092F55;
                z-index: 11;
                position: absolute;
                left: calc(50% - 144px);
                .text {
                    margin-right: 20px;
                    color: #FFF;
                    &:hover  {
                        color: #092F55;
                    }
                }
                .cooperation {
                    display: none;
                }
            }
            .fa-list-ul {
                display: none;
            }
            .selectLan {
                float: right;
                margin-top: 45px;
            }
            .fa-share-alt{
                float: right;
                margin-top: 48px;
                margin-right: 25px;
                color: white;
            }
        }
        .router-link-active {
            color: #092F55!important;
        }
        div.header-logo {
            height: 105px;
            background-color: $global-yellow-bc;
            border-top: 1px solid #eee;
            div.logo-container {
                max-width: 1170px;
                margin: 0 auto;
                height: 100%;
                display: flex;
                align-items: center;
                clear: both;
                img {
                    width: 40%;
                    // height: 63px;
                    display: block;
                    margin: 0 68px;
                }
            }
        }
    }
    .logo {
        border-bottom: none;
    }
    .community {
        background: #092F55;
        .router-link-active {
            color: #edae24!important;
        }
    }
}
@media screen and (min-width: 769px)  {
    .box {
        width: 100%;
        background: #edae24;
        margin-top: -80px;
        border-bottom: 1px solid #eee;
        .wrapper {
            max-width: 1170px;
            height: 75px;
            margin: 0 auto;
            #logo {
                float: left;
                margin-left: 68px;
                margin-top: 38px;
            }
            #links {
                float: left;
                margin-top: 45px;
                color: #092F55;
                z-index: 11;
                position: absolute;
                left: calc(50% - 120px);
                .text {
                    margin-right: 20px;
                    color: #FFF;
                    &:hover  {
                        color: #092F55;
                    }
                }
                .more {
                    display: inline-block;
                    position: relative;
                    padding-bottom: 8px;
                    .cooperation {
                        position: absolute;
                        top: 30px;
                        height: 0;
                        opacity: 0;
                        border: 1px solid #FFF;
                        padding: 7px;
                        width: 0px;
                        left: -8px;
                        line-height: 1.8rem;
                        box-shadow: 0 2px 20px 0 rgba(198,199,199,.5);
                        background: #edae24;
                        a {
                            display: block;
                            color: #FFF;
                            height: 0;
                            &:hover {
                                color: #092F55;
                            }
                        }
                    }
                    &:hover {
                        .cooperation {
                            opacity: 1;
                            width: 80px;
                            text-align: center;
                            overflow: hidden;
                            a {
                                height: 28px;
                            }
                        }
                        .news {
                            animation: newsAnimate .3s;
                            animation-fill-mode: forwards;
                        }
                        .coop {
                            animation: aaAnimate .3s;
                            animation-fill-mode: forwards;
                        }
                    }
                }
            }
            .fa-list-ul {
                display: none;
            }
            .selectLan {
                float: right;
                margin-top: 45px;
            }
            .fa-share-alt{
                float: right;
                margin-top: 50px;
                margin-right: 30px;
                color: white;
            }
        }
        .router-link-active {
            color: #092F55!important;
        }
        div.header-logo {
            height: 105px;
            background-color: $global-yellow-bc;
            border-top: 1px solid #eee;
            div.logo-container {
                max-width: 1170px;
                margin: 0 auto;
                height: 100%;
                display: flex;
                align-items: center;
                clear: both;
                img {
                    width: 40%;
                    // height: 63px;
                    display: block;
                    margin: 0 68px;
                }
            }
        }
    }
    .logo {
        border-bottom: none;
    }
    .community {
        background: #092F55;
        #links {
            .text {
                &:hover  {
                    color: #edae24!important;
                }
            }
            .more {
                .cooperation {
                    a {
                        &:hover {
                            color: #edae24!important;
                        }
                    }
                }
                &:hover {
                    .cooperation {
                        background: #092F55!important;
                    }
                }
            }
        }
        .router-link-active {
            color: #edae24!important;
        }
    }
    @keyframes aaAnimate
    {
        0%   {height: 0px;}
        100% {height: 128px;}
    }
    @keyframes newsAnimate
    {
        0%   {height: 0px;}
        100% {height: 96px;}
    }
}
@media screen and (max-width: 415px) {
    .box {
        width: 100%;
        background: #edae24;
        .wrapper {
            width: 100%;
            height: 75px;
            border-bottom: 1px solid #eee;
            #logo{
                float: left;
                margin-left: 10px;
                margin-top: 20px;
                img {
                    width: 120px;
                }
            }
            .fa-list-ul{
                float: right;
                margin-right: 10px;
                margin-top: 25px;
                color: white;
                font-size: 20px;
                display: inline-block;
            }
            #links {
                width: 74px;
                right: 10px;
                top: 60px;
                z-index: 11;
                position: absolute;
                background: #edae24;
                box-shadow: 0 0 10px rgba(0,0,0,0.3);
                border-radius: 0 0 8px 8px;
                .text {
                    display: block;
                    color: #FFF;
                    border-bottom: 1px solid rgba(255,255,255,0.4);
                    padding: 5px 0;
                    margin: 0 auto;
                    text-align: center;
                    font-size: 14px;
                    &:last-child {
                        border-bottom: none;
                    }
                }
                .cooperation {
                    display: none;
                }
            }
            .selectLan {
                float: right;
                margin-top: 22px;
                margin-right: 10px;
            }
            .fa-share-alt{
                float: right;
                margin-top: 25px;
                margin-right: 25px;
                color: white;
            }
        }
        div.header-logo {
            height: 90px;
            background-color: $global-yellow-bc;
            border-top: 1px solid #eee;
            div.logo-container {
                max-width: 1170px;
                margin: 0 auto;
                height: 100%;
                display: flex;
                align-items: center;
                clear: both;
                img {
                    width: 40%;
                    // height: 63px;
                    display: block;
                    margin: 0 15px;
                }
            }
        }
    }
    .logo {
        border-bottom: none;
    }
    .community {
        background: #092F55;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue